(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bb-sticky')) {
    customElements.define(
      'bb-sticky',
      class extends HTMLElement {
        connectedCallback() {
          this.title_ = this.querySelector('[data-bb-sticky-title]');
          this.sub = this.querySelector('[data-bb-sticky-sub]');
          this.price = this.querySelector('[data-bb-sticky-price]');
          this.choice = this.querySelector('[data-bb-sticky-choice]');
          this.idInput = this.querySelector('form.bb-buy input[name="id"]');
          this.btnPrice = this.querySelector('[data-bb-btn-price]');
          this.zone = null;
          this.saved = null;

          this.choice.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-pick]');
            if (btn && this.zone) this.pick(btn.dataset.pick);
          });

          const zone = document.querySelector('[data-bb-zone]');
          if (zone && 'IntersectionObserver' in window) {
            new IntersectionObserver(
              (entries) => entries.forEach((en) => (en.isIntersecting ? this.enter(zone) : this.leave())),
              { rootMargin: '-35% 0px -35% 0px' }
            ).observe(zone);
          }

          // Desktop: show the bar only when no other buy button is visible.
          const others = [...document.querySelectorAll('form.bb-buy')].filter((f) => !this.contains(f));
          if (others.length && 'IntersectionObserver' in window) {
            const seen = new Set();
            const io = new IntersectionObserver((entries) => {
              entries.forEach((en) => (en.isIntersecting ? seen.add(en.target) : seen.delete(en.target)));
              this.classList.toggle('is-shown', seen.size === 0);
            });
            others.forEach((f) => io.observe(f));
          } else {
            this.classList.add('is-shown');
          }
        }

        snapshot() {
          return {
            title: this.title_.textContent,
            sub: this.sub.textContent,
            price: this.price.textContent,
            id: this.idInput ? this.idInput.value : null,
          };
        }

        set(state) {
          this.title_.textContent = state.title;
          this.sub.textContent = state.sub;
          this.price.textContent = state.price;
          if (this.btnPrice) this.btnPrice.textContent = state.price;
          if (this.idInput && state.id) this.idInput.value = state.id;
        }

        enter(zone) {
          if (this.zone) return;
          this.zone = zone;
          this.saved = this.snapshot();
          const d = zone.dataset;
          const [b, x] = this.choice.querySelectorAll('[data-pick]');
          b.textContent = `${d.bbZoneBundleLabel} · ${d.bbZonePrice}`;
          x.textContent = `${d.bbZoneBaseLabel} · ${d.bbZoneBasePrice}`;
          this.choice.hidden = false;
          this.classList.add('is-zone');
          this.pick('bundle');
        }

        pick(which) {
          const d = this.zone.dataset;
          const bundle = which === 'bundle';
          this.set(
            bundle
              ? { title: d.bbZoneTitle, sub: d.bbZoneSub, price: d.bbZonePrice, id: d.bbZoneVariant }
              : { title: d.bbZoneBaseTitle, sub: this.sub.dataset.base, price: d.bbZoneBasePrice, id: d.bbZoneBaseVariant }
          );
          this.choice.querySelectorAll('[data-pick]').forEach((btn) => btn.setAttribute('aria-pressed', String(btn.dataset.pick === which)));
          this.classList.toggle('is-bundle', bundle);
        }

        leave() {
          if (!this.zone) return;
          this.zone = null;
          this.choice.hidden = true;
          this.classList.remove('is-zone', 'is-bundle');
          if (this.saved) this.set(this.saved);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
